import React from "react";

import { RequestStatusEnum } from "#/services/bridge/bridge.types";
import { useBridgeStatus } from "#/services/bridge/hooks/useBridgeStatus";

import { BridgeId } from "../../BridgeId/BridgeId";
import { QuoteCard } from "../../QuoteCard/QuoteCard";

interface BridgeHistoryItemProps {
  requestHash: string;
}

export const BridgeHistoryItem: React.FC<BridgeHistoryItemProps> = ({
  requestHash,
}) => {
  const { data: bridgeStatus } = useBridgeStatus(requestHash);

  if (!requestHash) {
    return null;
  }

  const output = bridgeStatus?.destinationData.output[0];
  const input = bridgeStatus?.originData.input[0];

  return (
    <div className="flex flex-1 flex-col gap-2">
      <QuoteCard
        input={input}
        output={output}
        variant="compact"
        isCompleted={
          (bridgeStatus?.bungeeStatusCode ?? 0) >= RequestStatusEnum.FULFILLED
        }
      />
      <BridgeId
        bridgeId={requestHash}
        status={bridgeStatus?.bungeeStatusCode}
      />
    </div>
  );
};
